export const home = "/";
export const contactUs = "/contact";
export const about = "/#about";
export const services = "/services";
export const works = "/works";
export const termsConditions = "/termsandconditions";
export const privacyPolicy = "/privacypolicy";
export const blog = "/blog";

export const careeros = "/works/career-os";
export const salesPacker = "/works/sales-packer";
export const meduzza = "/works/meduzza";
export const flamingo = "/works/flamingo";
export const seda = "/works/seda";
export const luminousMinds = "/works/luminous-minds";
export const textileGroup = "/works/textile-group";
